<button
  type="button"
  (click)="tapToTop()"
  [class.hidden]="!show()"
  aria-label="Back to top"
  class="fixed right-7.5 bottom-7.5 z-5 size-10 cursor-pointer rounded-full border-none bg-primary p-[7px] text-center text-white opacity-50 shadow-[0_0_10px_var(--primary-color)] transition-all duration-300 ease-css hover:opacity-100 [&_svg]:w-5"
>
  <app-feather-icons [icon]="'chevrons-up'"></app-feather-icons>
</button>
